"use client";

import { c as _c } from "react/compiler-runtime";
import { useOnborda } from "onborda";
import type { CardComponentProps } from "onborda";
import { RiCloseLine } from "react-icons/ri";
import Button from "@/components/ui/button";

/** Fired by "Done", just before the tour closes, so closing a tour early isn't finishing it. */
export const TOUR_FINISHED_EVENT = "decoda:tour-finished";
export default function TourCard(t0) {
  const $ = _c(34);
  const {
    step,
    currentStep,
    totalSteps,
    nextStep,
    prevStep,
    arrow
  } = t0;
  const {
    closeOnborda
  } = useOnborda();
  const isLast = currentStep === totalSteps - 1;
  let t1;
  if ($[0] !== step.title) {
    t1 = <h3 className="text-body-emphasis text-card-foreground">{step.title}</h3>;
    $[0] = step.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <RiCloseLine className="h-4 w-4" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== closeOnborda) {
    t3 = <button type="button" onClick={closeOnborda} className="ml-2 shrink-0 rounded-md p-0.5 text-foreground-muted hover:text-foreground">{t2}</button>;
    $[3] = closeOnborda;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className="mb-2 flex items-start justify-between">{t1}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== step.content) {
    t5 = <div className="mb-3 text-caption leading-relaxed text-foreground-secondary">{step.content}</div>;
    $[8] = step.content;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = currentStep + 1;
  let t7;
  if ($[10] !== t6 || $[11] !== totalSteps) {
    t7 = <span className="text-caption text-foreground-muted">{t6} of {totalSteps}</span>;
    $[10] = t6;
    $[11] = totalSteps;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== currentStep || $[14] !== prevStep) {
    t8 = currentStep > 0 && <Button variant="secondary" size="sm" onClick={prevStep}>Back</Button>;
    $[13] = currentStep;
    $[14] = prevStep;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== closeOnborda || $[17] !== isLast || $[18] !== nextStep) {
    t9 = isLast ? () => {
      window.dispatchEvent(new Event(TOUR_FINISHED_EVENT));
      closeOnborda();
    } : nextStep;
    $[16] = closeOnborda;
    $[17] = isLast;
    $[18] = nextStep;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = isLast ? "Done" : "Next";
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = <Button variant="primary" size="sm" onClick={t9}>{t10}</Button>;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t8) {
    t12 = <div className="flex items-center gap-1.5">{t8}{t11}</div>;
    $[23] = t11;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t7) {
    t13 = <div className="flex items-center justify-between">{t7}{t12}</div>;
    $[26] = t12;
    $[27] = t7;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== arrow || $[30] !== t13 || $[31] !== t4 || $[32] !== t5) {
    t14 = <div data-tour-card={true} className="w-[320px] rounded-lg border border-border bg-card p-4 shadow-lg">{t4}{t5}{t13}{arrow}</div>;
    $[29] = arrow;
    $[30] = t13;
    $[31] = t4;
    $[32] = t5;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
}